// extracted by mini-css-extract-plugin
export default {"wrapper":"table_wrapper__rsUQ6","scrollToEnd":"table_scrollToEnd__ceYEP"};